import { PanelResizeHandle } from "react-resizable-panels";
import React from "react";
import styles from "./ResizeHandle.module.scss";
import { GripHorizontal, GripVertical } from "lucide-react";

export default function ResizeHandle({
  className = "",
  orientation = "horizontal", // "horizontal" / "vertical"
}) {

  const orientationClass =
    orientation === "vertical" ? styles.Vertical : styles.Horizontal;

  return (
    <PanelResizeHandle
        className={[styles.ResizeHandleOuter, className].join(" ")}
    >
        <div className={styles.ResizeHandleInner}>
            {orientation === "horizontal" ? 
                <GripHorizontal className={styles.ResizeHandleIcon}/>
            :
                <GripVertical className={styles.ResizeHandleIcon}/>
            }
            
        </div>
    </PanelResizeHandle>
  );
}
